'use strict';
define(['./util', './analytics'], function (Utils, analytics) {

    function newsLettercomponent() {
        this.inputFieldElement = document.querySelector('.navfooter-email');
        this.formElementParms = document.querySelectorAll('.navfooter-formparms');
        this.emailErrormsg = document.querySelector('.navfooter-errormsg');
        this.alertIcon = document.querySelector('.nav-footer-alertdiv');
        this.emailSubmitButton = document.querySelector('.navfooter-sign--button');
        this.hoverMediaIcons = document.querySelectorAll('.navfooter-socialicons a img');
        this.validateInputfield = this.validateInputfield.bind(this);
        this.validateInputfieldonfocus = this.validateInputfieldonfocus.bind(this);
        this.changeImagesrc = this.changeImagesrc.bind(this);
        this.formstoreId = '';
        this.init();
    }

    newsLettercomponent.prototype.init = function () {
        this.bind();
    };

    newsLettercomponent.prototype.bind = function () {
        var _this = this;
        if (_this.inputFieldElement) {
            _this.inputFieldElement.addEventListener('blur', _this.validateInputfield);
            _this.inputFieldElement.addEventListener('focus', _this.validateInputfieldonfocus);
        }
        if (_this.emailSubmitButton) {
            _this.emailSubmitButton.addEventListener('click', _this.validateInputfield);
        }
        for (var i = 0; i < _this.hoverMediaIcons.length; i++) {
            _this.hoverMediaIcons[i].addEventListener('mouseover', _this.changeImagesrc);
            _this.hoverMediaIcons[i].addEventListener('mouseout', _this.changeImagesrc);
        }

        if (_this.emailSubmitButton) {
            analytics.bind(_this.emailSubmitButton, [{
                functionName: 'analyticsNewsLetterInputError',
                event: 'click'
            }]);
        }
        if (_this.inputFieldElement) {
            analytics.bind(_this.inputFieldElement, [{
                functionName: 'analyticsNewsLetterInput',
                event: 'focus'
            }]);
        }
    };

    newsLettercomponent.prototype.validateInputfield = function (evt) {
        var _this = this;

        if (_this.inputFieldElement && _this.inputFieldElement.value === '') {
            Utils.addClass(_this.inputFieldElement, 'nav-footer--invalidemail');
            Utils.addClass(_this.emailErrormsg, 'navfooter-errormsg-none');
            Utils.removeClass(_this.alertIcon, 'nav-footer-alertdivblock');
            _this.inputFieldElement.removeEventListener('input', _this.validateInputfield);
            evt.preventDefault();
        }

        else {
            if (/^[a-z\d._\+%&amp;\'\/=~$*?!`\-]+@[a-z0-9.\-]+\.[a-z]{2,24}$/i.test(_this.inputFieldElement.value)) {
                Utils.addClass(_this.emailErrormsg, 'navfooter-errormsg-none');
                Utils.removeClass(_this.alertIcon, 'nav-footer-alertdivblock');
                Utils.removeClass(_this.inputFieldElement, 'nav-footer--invalidemail');
                if(evt.type === 'click'){
                    document.querySelector('.navfooter-newsletterformelement').action += '&footerid='+window.btoa(this.inputFieldElement.value);
                }
            }
            else {
                Utils.addClass(_this.inputFieldElement, 'nav-footer--invalidemail');
                Utils.removeClass(_this.emailErrormsg, 'navfooter-errormsg-none');
                Utils.addClass(_this.alertIcon, 'nav-footer-alertdivblock');
                _this.inputFieldElement.addEventListener('input', _this.validateInputfield);
                evt.preventDefault();
            }
        }
    };

    newsLettercomponent.prototype.validateInputfieldonfocus = function () {
        if (this.inputFieldElement.value === '' && (Utils.hasClass(this.inputFieldElement, 'nav-footer--invalidemail'))) {
            Utils.removeClass(this.inputFieldElement, 'nav-footer--invalidemail');
        }

    };

    newsLettercomponent.prototype.changeImagesrc = function (evt) {
        var hoverimagesrc = evt.target.getAttribute('src');
        evt.target.src = evt.target.getAttribute('data-originalsrc');
        evt.target.setAttribute('data-originalsrc', hoverimagesrc);
    };



    return newsLettercomponent;
});




/** WEBPACK FOOTER **
 ** ./src/mns-core-ui-footer/templates/footer/js/newsLettercomponent.js
 **/